<template>
    <div class="footer-area-wrapper" :class="FooterStyle">
        <div class="footer-area section-space--ptb_90">
            <div class="container">
                <div class="row footer-widget-wrapper">
                    <div class="col-lg-4 col-md-6 footer-widget">
                        <div class="footer-widget__logo mb-30">
                            <router-link to="/">
                                <img src="../assets/img/logo/logo-dark.png" class="img-fluid logo-dark" alt="logo">
                                <img src="../assets/img/logo/logo-light.png" class="img-fluid logo-light" alt="logo">
                            </router-link>
                        </div>
                        <ul class="footer-widget__list">
                            <li>Contatti: </li>
                            <li>
                                <a href="mailto:info@64-bit-it" class="hover-style-link">info@64-bit-it</a>
                            </li>
                            <li>
                                <a href="tel:3284736326" class="hover-style-link">T 3284736326</a>
                            </li>
                            <li>
                                <a href="https://64-bit.it" target="_blank" class="hover-style-link hover-style-link--green">64-bit.it</a>
                            </li>
                        </ul>
                    </div>
                    <div class="col-lg-2 col-md-6 footer-widget">
                        
                    </div>
                    <div class="col-lg-2 col-md-6 footer-widget">
                        
                    </div>
                    <div class="col-lg-3 col-md-6 offset-lg-1 footer-widget">
                        <a href="https://64-bit.it"><img src="../assets/img/icons/logo-trasp.png" class="img-fluid" alt="64-bit"></a>
                    </div>
                </div>
            </div>
        </div>
        <div class="footer-copyright-area border-top section-space--ptb_30">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-md-6 text-center text-md-left">
                        <span class="copyright-text">
                            &copy; 2023 <b>64-bit</b> Made with <i class="fa fa-heart text-danger"></i> by <a href="https://64-bit.it"><b>64-bit team.</b></a>
                        </span>
                    </div>
                    <div class="col-md-6 text-center text-md-right">
                        * questo sito non utilizza cookies di profilazione.
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'FooterMain',
        props: ["FooterStyle"]
    }
</script>
